












import {
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs,
  watch
} from '@vue/composition-api'
import vClickOutside from 'v-click-outside'
import { usePopupPosition } from '../../composables/usePopupPosition'

export default defineComponent({
  name: 'Popup',
  directives: {
    clickOutside: vClickOutside.directive
  },
  emits: ['hide'],
  props: {
    root: {
      type: HTMLElement,
      required: false
    },
    target: {
      required: true
    },
    position: {
      required: false,
      default: 'center'
    },
    verticalSpace: {
      required: false,
      default: 0
    },
    stickToPosition: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickOutside(e: Event) {
      this.$emit('hide', e)
    }
  },
  setup(props) {
    const left = ref<number>(0)
    const top = ref<number>(0)
    const animated = ref<boolean>(false)
    const shown = ref<boolean>(false)
    const { target, root, position, verticalSpace, stickToPosition } = toRefs(
      props
    )
    const initialPosition = ref<{ left: number; top: number } | null>(null)

    const popup = ref<HTMLElement | null>(null)

    function getTarget(): DOMRect {
      if (target.value instanceof HTMLElement) {
        return target.value.getBoundingClientRect()
      }

      if (target.value instanceof DOMRect) {
        return target.value
      }

      return document.documentElement.getBoundingClientRect()
    }

    const _root: HTMLElement = root
      ? root.value || document.documentElement
      : document.documentElement

    const isAnimated = computed(() => left.value !== 0 && top.value !== 0)

    const checkPosition = () => {
      if (popup.value) {
        const pos = usePopupPosition(
          getTarget(),
          _root,
          popup.value,
          position.value,
          verticalSpace.value
        )
        if (pos) {
          left.value = pos?.leftPos
          top.value = pos?.topPos
        }
      }
    }

    onMounted(() => {
      setTimeout(() => {
        animated.value = isAnimated.value
      }, 100)
      checkPosition()
      shown.value = true
      if (stickToPosition.value) {
        initialPosition.value = { left: left.value, top: top.value }
      }
    })
    watch(target, (f, t) => {
      if (JSON.stringify(f) !== JSON.stringify(t)) {
        checkPosition()
      }
    })
    watch(
      [target, stickToPosition],
      () => {
        if (stickToPosition.value && initialPosition.value) {
          left.value = initialPosition.value.left
          top.value = initialPosition.value.top
        } else {
          checkPosition()
        }
      },
      { immediate: true }
    )

    const positionStyle = computed(() => ({
      left: `${left.value}px`,
      top: `${top.value}px`
    }))

    return {
      positionStyle,
      popup,
      shown,
      animated
    }
  }
})
